export function getProfileUserId(user) {
  if (!user) return null;
  if (typeof user === "string") return user;
  return user._id || user.id || null;
}

/** Strip cache-buster query params added for browser refresh — not for DB storage. */
export function stripAvatarCacheBuster(url) {
  if (!url || typeof url !== "string") return url;
  return url.replace(/([?&])_t=\d+(?=&|$)/, "$1").replace(/[?&]$/, "");
}

export function getProfileAvatarUrl(user) {
  if (!user) return null;
  const url =
    user?.profile?.avatarImage ||
    user?.profile?.avatar ||
    user?.avatarImage ||
    user?.avatar ||
    null;
  if (typeof url !== "string") return null;
  const trimmed = stripAvatarCacheBuster(url.trim());
  return trimmed || null;
}

export function getProfileDisplayLabel(user, { preferUsername = true, fallback = "—" } = {}) {
  if (!user) return fallback;
  if (preferUsername && user.username) return `@${user.username}`;
  return user.businessName || user.username || fallback;
}

export function getProfileInitial(user, fallback = "?") {
  const label = getProfileDisplayLabel(user, { preferUsername: false, fallback });
  return (label || fallback).charAt(0).toUpperCase();
}
